// src/store/modules/processing.js

const state = {
  isVisible: false,
  logs: []
}

const mutations = {
  SET_VISIBLE(state, isVisible) {
    state.isVisible = isVisible
  },
  SET_LOGS(state, logs) {
    // Ensure logs is always an array
    state.logs = logs || []
  },
  PUSH_LOG(state, log) {
    state.logs.push(log)
  }
}

const actions = {
  // Matches Go Packet: Packet("openProcessModal", existingLogs)
  // vue-native-websocket usually prefixes socket actions with SOCKET_
  openProcessModal({ commit }, message) {
    // The message.data contains the array of existing logs (for F5 reconnects)
    commit('SET_LOGS', message.data)
    commit('SET_VISIBLE', true)
  },

  // Matches Go Packet: Packet("updateProcessLog", "log string")
  updateProcessLog({ commit }, message) {
    commit('PUSH_LOG', message.data)
  },

  // Matches Go Packet: Packet("closeProcessModal", nil)
  closeProcessModal({ commit }) {
    // Wait a tiny bit so the user sees the "Success" log before it vanishes
    setTimeout(() => {
      commit('SET_VISIBLE', false)
      commit('SET_LOGS', [])
    }, 1500)
  }
}

const getters = {
  isProcessing: state => state.isVisible,
  processLogs: state => state.logs
}

export default {
  state,
  mutations,
  actions,
  getters
}
